export const dropOffPointRadioName = 'drop-off-point'

export const searchingDropOffPointsMessages = ['Buscando puntos de recogida cerca de tu dirección...']
